"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _blockEditable = _interopRequireDefault(require("../block-editable"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function BlockTranslatable(_ref) {
  var original = _ref.original,
      translation = _ref.translation,
      onTranslation = _ref.onTranslation,
      inputFilters = _ref.inputFilters,
      outputFilters = _ref.outputFilters,
      style = _ref.style,
      preview = _ref.preview;
  var classes = useStyles();
  var originalBlock = (0, _react.useMemo)(function () {
    return _react.default.createElement(_blockEditable.default, {
      markdown: original,
      inputFilters: inputFilters,
      outputFilters: outputFilters,
      preview: preview,
      editable: false
    });
  }, [original, inputFilters, outputFilters, preview]);
  var translationBlock = (0, _react.useMemo)(function () {
    return _react.default.createElement(_blockEditable.default, {
      markdown: translation,
      onEdit: onTranslation,
      inputFilters: inputFilters,
      outputFilters: outputFilters,
      preview: preview,
      editable: true
    });
  }, [translation, onTranslation, inputFilters, outputFilters, preview]);
  return _react.default.createElement(_core.Grid, {
    container: true,
    wrap: "nowrap",
    spacing: 0,
    className: classes.root,
    style: style
  }, _react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.original
  }, originalBlock), _react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.translation
  }, translationBlock));
}

;
BlockTranslatable.propTypes = {
  /** Original markdown for the editor. */
  original: _propTypes.default.string.isRequired,

  /** Translation markdown for the editor. */
  translation: _propTypes.default.string.isRequired,

  /** Function to propogate changes to the translation. */
  onTranslation: _propTypes.default.func.isRequired,

  /** Replace strings before rendering. */
  inputFilters: _propTypes.default.array,

  /** Replace strings after editing. */
  outputFilters: _propTypes.default.array,

  /** CSS for the component. */
  style: _propTypes.default.object,

  /** Display Raw Markdown or HTML. */
  preview: _propTypes.default.bool
};
BlockTranslatable.defaultProps = {
  original: '',
  translation: '',
  inputFilters: [],
  outputFilters: [],
  style: {},
  preview: true
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    original: {
      background: '#eee4'
    },
    translation: {}
  };
});
var _default = BlockTranslatable;
exports.default = _default;